import * as lambda from "./ShippingCallsNew"
import * as type from "../constants/actions/ShippingActionTypes";
import * as errorTypes from "../constants/actions/ShippingErrorTypes";
import * as store from "./StoreActions";
import * as cogLib from "../libs/cognitoLib"
import config from "../config";
import * as notification from './NotificationActions'
import * as jsPDF from 'jspdf';

//Shipment Constants
import METHOD from "../constants/shipping/MethodTypesNew";
import STATUS from "../constants/shipping/StatusTypesNew";
import {getProductsBySkus} from './catalog/CatalogCalls'

var moment = require('moment-timezone');

const loading = (loading) => {
    return (
        {
            type:type.LOADING_SHIPMENTS,
            loading:loading
        }
    )
};

const loadingOpen = (loading) => {
    return (
        {
            type:type.LOADING_OPEN_SHIPMENTS,
            loading:loading
        }
    )
};

const loadingFulfilled = (loading) => {
    return (
        {
            type:type.LOADING_FULFILLED_SHIPMENTS,
            loading:loading
        }
    )
};

export const loggedIn = (login) => {
    return (
        {
            type:type.LOG_IN,
            payload:login
        }
    )
};

const addShipment =  (shipments) => {
    return (
        {
            type:type.ADD_SHIPMENTS,
            payload:shipments
        }
    )
};

const clearShipments = ()=> {
    return (
        {
            type:type.CLEAR_SHIPMENTS
        }
    )
};

const addFulfilledShipments = (shipments) => {
    return {
        type: type.ADD_FULFILLED_SHIPMENTS,
        payload: shipments
    }
};

const clearFulfilledShipments = () => {
    return {
        type: type.CLEAR_FULFILLED_SHIPMENTS
    }
};

const setFocusedShipment = (shipment) => ({
    type: type.SET_FOCUSED_SHIPMENT,
    payload: shipment
});

const setAuspostInfo = (auspost) =>{
    return (
        {
            type:type.SET_AUSPOST_DETAILS,
            payload:auspost
        }
    )
};

const setLabels = (shipmentId,labels) => {
    return (
        {
            type:type.SET_AUSPOST_LABEL,
            shipmentId: shipmentId,
            payload:labels
        }
    )
}

const setIbt = (shipmentId,ibt) => {
    return (
        {
            type:type.SET_REJECTED_IBT,
            shipmentId: shipmentId,
            payload:ibt
        }
    )
}

const addPendingOverview = (data) => {
    return (
        {
            type:type.PENDING_OVERVIEW,
            payload:data
        }
    )
}

const updateShipmentInView = (shipment) => {
    return (
        {
            type:type.UPDATE_SHIPMENT,
            shipment: shipment
        }
    )
}

const addNewShipmentToView = (shipment) => {
    return (
        {
            type:type.ADD_NEW_SHIPMENT,
            shipment: shipment
        }
    )
}

const removeShipmentFromView = (shipment) => {
    return (
        {
            type:type.REMOVE_SHIPMENT,
            shipment: shipment
        }
    )
}

/**
 * Using itemId to change item availability
 */
export function updateItemAvailability (shipmentId, itemId, availability, reason) {
    return (
        {
            type: type.UPDATE_ITEM_AVAILABILITY,
            shipmentId: shipmentId,
            itemId: itemId,  // Use itemId (shipmentItemId) instead of localId
            avail: availability,
            reason: reason ? reason : null
        }
    )
}

export function updateShipmentStatus(shipmentId,status){
    return (
        {
            type:type.UPDATE_SHIPMENT_STATUS,
            shipmentId:shipmentId,
            status:status,
        }
    )
}
export function updateShipmentStage(stage,shipmentId){
    return (
        {
            type:type.UPDATE_SHIPMENT_STAGE,
            payload:stage,
            shipmentId:shipmentId
        }
    )
}

export function updateFulfiller(fulfiller){
    return (
        {
            type:type.UPDATE_FULFILLER,
            payload:fulfiller
        }
    )
}

export function updateShipmentsWithFulfiller(fulfiller){
    return (
        {
            type:type.UPDATE_SHIPMENTS_WITH_FULFILLER,
            payload:fulfiller
        }
    )
}

export function updateProductImages(images) {
    return (
        {
            type:type.UPDATE_ITEM_IMAGES,
            images,
        }
    )
}

/*Fetch and Logic functions*/
 const fetchResponsibleShipments = (store) => {
  return () => {
      return lambda.getResponsibleShipments(store).then(response => {
          return response;
      }).catch(error => {
          console.error('fetchResponsibleShipments API error:', error);
          // Return error object so it can be handled upstream
          return { error: true, message: error.message || 'Network error' };
      })
    }
};

 const fetchSingleReponsibleShipment = (shipmentId)=>{
    return () => {
        return lambda.getSingleResponsibleShipment(shipmentId).then(response => {
            return response;
        })
    }
}

const fetchLabel = (shipmentId, packageComposition, shippingAddress, fulfiller, fulfilledAt, rejectedItems = null) => {
    return() => {
        return lambda.getLabel(shipmentId, packageComposition, shippingAddress, fulfiller, fulfilledAt, rejectedItems).then(response => {
            return response;
        }).catch({

        })
    }
};

const fetchPickslip = (shipmentId, store) => {
    return() => {
        return lambda.getPickslip(shipmentId, store).then(response => {
            return response;
        })
    }
};

const fetchCCLabel = (storeId, shipmentId, brand) => {
    return() => {
        return lambda.generateCCLabel(storeId, shipmentId, brand).then(response=>{
            return response;
        })
    }
};

const fetchAllPickslips = (store, type, web_store) => {
    return() => {
        return lambda.getAllPickslips(store, type, web_store).then(response => {
            return response;
        })
    }
};

const fulfillShipment = (storeId, shipmentToEdit, status, collection=false) =>{
    return() => {
        return lambda.fulfillShipment(storeId, shipmentToEdit, status, collection).then(response => {
            return response;
        })
    }
};

const fulfilShipment = (shipment,storeId,status) =>{
    return() => {
        return lambda.fulfilShipment(shipment,storeId,status).then(response => {
            return response;
        })
    }
};

const rejectShipment = (shipmentId, rejectedItems) => {
    return() => {
        return lambda.rejectShipment(shipmentId, rejectedItems).then(response => {
            return response;
        });
    };
};

const getFulfilledByIncrement = (incrementId,store) => {
    return () => {
        return lambda.queryFulfilledByIncrement(incrementId,store).then(response => {
            return response;
        })
    }
};

const fetchPendingDetails = (store,userId=null) => {
    return () => {
        return lambda.getPendingShipments(store,null,userId).then(response => {
            return response;
        })
    }
};

const fetchFulfillerData = (store,futuraId) => {
    return () => {
        return lambda.getFulfillerData(store,futuraId).then(response => {
            return response;
        })
    }
};

const setSearchedShipments = (shipments) => {
    return {
        type: type.SET_SEARCHED_SHIPMENT,
        payload: shipments
    }
};

/**
 *
 * @returns {function(*, *): *}
 */
export function getShipments () {
    return (dispatch,getState) => {
        dispatch(loadingOpen(true));
        dispatch(clearShipments());
        let store = getState().authState.store;

        return dispatch(fetchResponsibleShipments(store)).then(response => {
            if(response.error) {
                dispatch(notification.refreshAction());
                dispatch(loadingOpen(false));
                return;
            }

            // Verify response structure
            if (!response.data || !response.data.shipments) {
                console.error('Unexpected response structure:', response);
                dispatch(loadingOpen(false));
                return;
            }

            const shipments = response.data.shipments.map(shipment => {
                return {
                    shipmentId: shipment.shipment_id,
                    incrementId: shipment.shipment_id,
                    carrier: shipment.carrier,
                    method: shipment.shipping_method,
                    brand: shipment.brand,
                    status: shipment.status,
                    pickslipUrl: shipment.pickslip_url,
                    fulfilledAt: shipment.fulfilled_at,
                    orderedAt: shipment.ordered_at,
                    customerName: shipment.customer_name,
                    parcels: shipment.packages,
                    items: shipment.shipment_items.map(item => ({
                        shipmentItemId: item.shipment_item_id,
                        name: item.name,
                        size: item.size,
                        sku: item.sku,
                        imageUrl: item.image_url,
                        // Backwards compatibility fields
                        localId: item.sku,
                        availability: true,
                        reason: null
                    })),
                    // Backwards compatibility fields
                    onlineStoreId: shipment.brand,
                    stage: null,
                    labelsPrinted: false,
                    createdAt: shipment.ordered_at // For timer functionality
                };
            });

            // Handle the new response structure
            const sortedShipments = shipments.sort((a, b) => {
                if (isPriorityShipment(a,b)) {
                    return comparePriorityShipment(a, b);
                }
                return compareShipment(a,b);
            });

            dispatch(addShipment(sortedShipments));
            dispatch(updateShipmentsWithFulfiller(getState().shippingState.fulfiller.futuraId));
            dispatch(loadingOpen(false));
        }).catch(() => {
            dispatch(notification.refreshAction());
            dispatch(loadingOpen(false));
        })
    }
}

export function getProductImages(skus) {
    return (dispatch, getState) => {
        let store_view_code = getState().authState.store_view_code;
        return getProductsBySkus(skus, store_view_code).then(response => {
            dispatch(updateProductImages(response.images));
        })
    }
}

export function getCCShipments() {
    return (dispatch,getState) => {
        dispatch(loading(true));
        // Only clear shipments if we don't have any yet
        const currentShipments = getState().shippingState.shipments;
        if (!currentShipments || currentShipments.length === 0) {
            dispatch(clearShipments());
        }
        let store = getState().authState.store;
        return dispatch(fetchResponsibleShipments(store)).then(response => {
            if (response.error) {
                console.error('Error retrieving responsible shipments:', response.error);
                dispatch(loading(false));
                // Return rejected promise to trigger error handling
                return Promise.reject(new Error('Failed to retrieve shipments'));
            } else {
                console.log('Received shipments response:', response);

                // Check if response.data and response.data.shipments exist
                if (!response.data || !response.data.shipments) {
                    console.error('Unexpected response structure:', response);
                    dispatch(loading(false));
                    return Promise.reject(new Error('Invalid response structure'));
                }

                // Filter for CLICKCOLLECT shipments that are FULFILLED
                let shipments = response.data.shipments.filter(obj => 
                    obj.carrier === "CLICKCOLLECT" && 
                    obj.status === "FULFILLED"
                );

                // Map to internal format
                const mappedShipments = shipments.map(shipment => ({
                    shipmentId: shipment.shipment_id,
                    incrementId: shipment.shipment_id,
                    carrier: shipment.carrier,
                    method: shipment.shipping_method,
                    brand: shipment.brand,
                    status: shipment.status,
                    pickslipUrl: shipment.pickslip_url,
                    fulfilledAt: shipment.fulfilled_at,
                    orderedAt: shipment.ordered_at,
                    customerName: shipment.customer_name,
                    bagCount: shipment.packages.length,
                    items: shipment.shipment_items.map(item => ({
                        name: item.name,
                        size: item.size,
                        sku: item.sku,
                        imageUrl: item.image_url,
                        localId: item.sku,
                        availability: true,
                        reason: null
                    }))
                }));

                dispatch(addShipment(mappedShipments));
                dispatch(updateShipmentsWithFulfiller(getState().shippingState.fulfiller.futuraId));
                dispatch(loading(false));
                return Promise.resolve(mappedShipments);
            }
        }).catch(error => {
            console.error('getCCShipments error:', error);
            dispatch(loading(false));
            // Re-throw to allow component to handle
            throw error;
        })
    }
}

export function searchShipments(text, archived = false) {
    return (dispatch,getState) => {
        dispatch(loading(true));
        let allShipments = getState().shippingState.allShipments;
        let store = getState().authState.store;
        if(archived) {
            if(text.length > 0) {
                // NEW: Use the recent fulfilled API when checkbox is checked
                return lambda.getRecentFulfilledShipments(store).then(response => {
                    console.log('Recent fulfilled shipments response:', response);
                    if(response && response.data && response.data.shipments) {
                        // Map shipments to internal format
                        const mappedShipments = response.data.shipments.map(shipment => {
                            // Extract items from packages if shipment_items is empty
                            let items = [];
                            if (shipment.shipment_items && shipment.shipment_items.length > 0) {
                                items = shipment.shipment_items.map(item => ({
                                    shipmentItemId: item.shipment_item_id,
                                    name: item.name,
                                    size: item.size,
                                    sku: item.sku,
                                    imageUrl: item.image_url,
                                    localId: item.sku,
                                    availability: true,
                                    reason: null
                                }));
                            } else if (shipment.packages && shipment.packages.length > 0) {
                                // Extract items from packages array
                                items = shipment.packages.flatMap(pkg => 
                                    pkg.shipment_items ? pkg.shipment_items.map(item => ({
                                        shipmentItemId: item.shipment_item_id,
                                        name: item.name || `Item ${item.shipment_item_id}`,
                                        size: item.size || '',
                                        sku: item.sku || item.shipment_item_id,
                                        imageUrl: item.image_url || '',
                                        localId: item.shipment_item_id,
                                        weight: item.weight,
                                        availability: true,
                                        reason: null
                                    })) : []
                                );
                            }
                            
                            return {
                                shipmentId: shipment.shipment_id,
                                incrementId: shipment.shipment_id,
                                carrier: shipment.carrier,
                                method: shipment.shipping_method,
                                brand: shipment.brand,
                                status: shipment.status,
                                pickslipUrl: shipment.pickslip_url,
                                fulfilledAt: shipment.fulfilled_at,
                                orderedAt: shipment.ordered_at,
                                customerName: shipment.customer_name,
                                localLabelUrl: shipment.local_label_url,
                                packages: shipment.packages,
                                items: items,
                                onlineStoreId: shipment.brand,
                                stage: null,
                                labelsPrinted: false,
                                createdAt: shipment.ordered_at,
                                isSearched: true
                            };
                        });
                        
                        // Filter by search text
                        const filteredShipments = mappedShipments.filter(x => 
                            x.shipmentId.toLowerCase().includes(text.toLowerCase())
                        );
                        
                        dispatch(addFulfilledShipments(filteredShipments));
                        dispatch(setSearchedShipments(filteredShipments));
                        dispatch(loading(false));
                    } else {
                        dispatch(getShipments());
                        dispatch(setSearchedShipments([]));
                    }
                }).catch(error => {
                    console.error('Error fetching recent fulfilled shipments:', error);
                    // Fallback to original behavior
                    dispatch(getShipments());
                    dispatch(setSearchedShipments([]));
                    dispatch(loading(false));
                });
            } else {
                dispatch(getShipments());
                dispatch(setSearchedShipments([]));
            }
        } else {
            // ORIGINAL CODE: unchanged for when checkbox is not checked
            if(text.length > 0) {
                // Update to use shipmentId instead of incrementId if that's the new identifier
                let newArray = allShipments.filter(x => x.shipmentId.includes(text));
                dispatch(addShipment(newArray));
                dispatch(setSearchedShipments(newArray));
                dispatch(loading(false));
            } else {
                dispatch(getShipments());
                dispatch(setSearchedShipments([]));
            }
        }
    };
}

export function reloadShipments() {
    return (dispatch,getState) => {
        dispatch(clearShipments());
        dispatch(loading(true));
        let store = getState().authState.store;
        return dispatch(fetchResponsibleShipments(store)).then(response => {
            if(response.error) {
                console.log('error retrieving responsible shipments');
                dispatch(loading(false));
            } else {
                // Check if response.data and response.data.shipments exist
                if (!response.data || !response.data.shipments) {
                    console.error('Unexpected response structure:', response);
                    dispatch(loading(false));
                    return;
                }
                
                // Map response to match component expectations
                const shipments = response.data.shipments.map(shipment => ({
                    shipmentId: shipment.shipment_id,
                    incrementId: shipment.shipment_id,
                    carrier: shipment.carrier,
                    method: shipment.shipping_method,
                    brand: shipment.brand,
                    status: shipment.status,
                    pickslipUrl: shipment.pickslip_url,
                    fulfilledAt: shipment.fulfilled_at,
                    orderedAt: shipment.ordered_at,
                    customerName: shipment.customer_name,
                    items: shipment.shipment_items.map(item => ({
                        name: item.name,
                        size: item.size,
                        sku: item.sku,
                        imageUrl: item.image_url,
                        localId: item.sku,
                        availability: true,
                        reason: null
                    })),
                    onlineStoreId: shipment.brand,
                    stage: null,
                    labelsPrinted: false,
                    createdAt: shipment.ordered_at
                }));
                dispatch(addShipment(shipments));
                dispatch(updateShipmentsWithFulfiller(getState().shippingState.fulfiller.futuraId));
                dispatch(loading(false));
            }
        })
    }
}

/**
 * Function that notifies frontend user when there is any updates with a shipment triggered by the API
 * @param shipmentId
 * @param type
 * @returns {function(*, *): (*|undefined)}
 */
export function updateShipmentLive(shipmentId,type){
    return (dispatch,getState) => {
        //let loggedIn = getState().shippingState.loggedIn
        return dispatch(fetchSingleReponsibleShipment(shipmentId)).then(response => {
            if(response.status){
                let shipment = response.shipment
                dispatch(updateShipmentInView(shipment));
                //dispatch(notification.shipmentNotification(createShipmentMessage(type,shipment)));
            }
        })
        if(loggedIn){
        }else {
            //dispatch(notification.shipmentNotification('There was an update with a shipment'));
        }
    }
}

/**
 * Function that notifies frontend user when there is a new shipment for their store triggered by the API
 * @param shipmentId
 * @returns {function(*, *): *}
 */
export function addShipmentLive(shipmentId){
    return (dispatch,getState) => {
        let loggedIn = getState().shippingState.loggedIn
        if(loggedIn){
            return dispatch(fetchSingleReponsibleShipment(shipmentId)).then(response => {
                let shipment = response.shipment
                dispatch(addNewShipmentToView(shipment));
                //dispatch(notification.shipmentNotification(createShipmentMessage("ADD_SHIPMENT",shipment)));
            })
        }else {
            //dispatch(notification.shipmentNotification('You have a new shipment to fulfill'));
        }
    }
}

export const getFocusedShipment = (shipment) => (dispatch, getState) => {
    const currentFocused = getState().shippingState.focusedShipment;
    if (currentFocused !== shipment) {
        dispatch(setFocusedShipment(shipment));
    }
};


/**
 * Updating shipments in the backend for C&C / SFS
 * @param shipmentId - shipment to update
 * @param status - what status we are updating the backend with
 * @param reason - if was rejected, a reason is provided
 * @param collection - if collection si true, shipment will be treated as a click and collect order and follows a different flow
 * @returns {Function}
 */
export function updateShipment(shipmentId, status, reason=false, collection=false) {
    return (dispatch,getState) => {
        console.log('Starting updateShipment:', { shipmentId, status, reason, collection });
        dispatch(loading(true));
        dispatch(updateShipmentStatus(shipmentId, status));

        let shipments = getState().shippingState.shipments;
        let storeId = getState().authState.store;
        console.log('Store ID:', storeId);

        let shipmentToEdit = shipments.find(x => x.shipmentId === shipmentId);
        console.log('Found shipment to edit:', shipmentToEdit);

        if (!shipmentToEdit) {
            console.error('Shipment not found:', shipmentId);
            dispatch(notification.errorNotification('Shipment not found! Please try again'));
            dispatch(loading(false));
            return;
        }

        // Clear label and add fulfiller info
        shipmentToEdit.label = "";
        const fulfiller = getState().shippingState.fulfiller.futuraId;
        console.log('Adding fulfiller to shipment:', fulfiller);
        shipmentToEdit.fulfiller = fulfiller;

        if (collection) {
            console.log('Processing collection shipment');
            if (status === "COMPLETE") {
                console.log('Marking collection as COMPLETE');
                dispatch(fulfilShipment(shipmentToEdit, storeId, status))
                    .then((response) => {
                        if (response.status || response.code === 200) {
                            dispatch(loading(false));
                            dispatch(notification.successNotification('Shipment successfully picked up.'));
                        } else {
                            throw new Error('Invalid response status');
                        }
                    })
                    .catch((e) => {
                        console.error('Error fulfilling collection shipment:', e);
                        dispatch(notification.errorNotification('Network error! Please try again'));
                        dispatch(loading(false));
                        dispatch(updateShipmentStage('STAGE_THREE', shipmentId));
                    });
            } else if (status === "REJECTED") {
                console.log('Processing REJECTED collection');
                const rejectedItems = shipmentToEdit.items
                    .filter(item => item.availability === false && item.reason)
                    .map(item => ({
                        shipment_item_id: item.shipmentItemId,
                        rejection_reason: mapRejectionReason(item.reason)
                    }));
                console.log('Rejected items:', rejectedItems);

                dispatch(rejectShipment(shipmentId, rejectedItems))
                    .then((response) => {
                        console.log('Reject shipment response:', response);
                        if (response.status) {
                            if ('rejection' in response) {
                                console.log('Creating faulty item PDF');
                                let pdf = createFaultyItemPdf(response.rejection);
                                let url = printPreview(pdf);
                                dispatch(setIbt(shipmentId, url));
                            }
                            dispatch(loading(false));
                        } else {
                            throw new Error('Rejection failed');
                        }
                    })
                    .catch((e) => {
                        console.error('Error rejecting collection shipment:', e);
                        dispatch(notification.errorNotification('Network error! Please try again'));
                        dispatch(loading(false));
                        dispatch(updateShipmentStage('STAGE_THREE', shipmentId));
                    });
            } else if (status === "COLLECTED") {
                dispatch(collectShipment(shipmentId))
                    .then((response) => {
                        if (response.message === 'success' || response.code === 200) {
                            dispatch(loading(false));
                            dispatch(notification.successNotification('Shipment successfully marked as collected.'));
                        } else {
                            throw new Error('Collect shipment failed');
                        }
                    })
                    .catch((e) => {
                        console.error('Error collecting shipment:', e);
                        dispatch(notification.errorNotification('Network error! Please try again'));
                        dispatch(loading(false));
                    });
            } else {
                console.log('Processing regular collection fulfillment');
                dispatch(loading(false));
            }
        } else {
            console.log('Processing non-collection shipment');
            if (status === "COMPLETE") {
                console.log('Marking non-collection as COMPLETE');
                dispatch(updateShipmentStage('STAGE_THREE', shipmentId));
                // dispatch(removeShipmentFromView({shipmentId}));
                dispatch(loading(false));
            } else if (status === "REJECTED") {
                console.log('Processing REJECTED non-collection');
                const rejectedItems = shipmentToEdit.items
                    .filter(item => item.availability === false && item.reason)
                    .map(item => ({
                        shipment_item_id: item.shipmentItemId,
                        rejection_reason: mapRejectionReason(item.reason)
                    }));
                console.log('Rejected items for non-collection:', rejectedItems);

                dispatch(rejectShipment(shipmentId, rejectedItems))
                    .then((response) => {
                        console.log('Non-collection reject response:', response);
                        if (response.status) {
                            if ('rejection' in response) {
                                console.log('Creating faulty item PDF for rejected non-collection');
                                let pdf = createFaultyItemPdf(response.rejection);
                                let url = printPreview(pdf);
                                dispatch(setIbt(shipmentId, url));
                            }
                        }
                        dispatch(loading(false));
                    })
                    .catch((e) => {
                        console.error('Error rejecting non-collection shipment:', e);
                        dispatch(notification.errorNotification('Network error! Please try again'));
                        dispatch(loading(false));
                        dispatch(updateShipmentStage('STAGE_THREE', shipmentId));
                    });
            }
        }
    };
}

// Takes in barcodes and collection code to validate collected shipment

export function validateCollectShipment(barcodes, collectionCode) {
    // Start loading

    return (dispatch,getState) => {
        dispatch(loading(true));

        const store = getState().authState.store

        // Dispatch the updated action with the new payload
        dispatch(collectShipment( barcodes, collectionCode, store))
            .then((response) => {
                if (response.message === 'success' || response.code === 200) {
                    dispatch(loading(false));
                    dispatch(notification.successNotification('Shipment successfully marked as collected.'));
                } else {
                    throw new Error(response.message || 'Collect shipment failed');
                }
            })
            .catch((e) => {
                dispatch(loading(false));
                
                let errorText = 'Network error! Please try again';

                // Axios style error
                if (e.response && e.response.data && e.response.data.message) {
                    errorText = e.response.data.message;
                } else if (e.message) {
                    errorText = e.message;
                }

                let errorResponse = JSON.parse(errorText);

                console.error('Error collecting shipment:', e);
                const invalidBagsMessage = errorResponse.invalid_bags && errorResponse.invalid_bags.length > 0 
                    ? ` Invalid Bags: ${errorResponse.invalid_bags.join(', ')}` 
                    : '';
                dispatch(notification.errorNotification(`${errorResponse.message || errorText}${invalidBagsMessage}`));
            });
    }
}

// Add helper function to map frontend rejection reasons to API format
function mapRejectionReason(reason) {
    const reasonMap = {
        'out_of_stock': 'OUT_OF_STOCK',
        'on_hold': 'ON_HOLD',
        'manufacturing_fault': 'MANUFACTURING_FAULT',
        'damaged_item_sell_in_store': 'DAMAGED_ITEM',
        'faulty': 'FAULTY'
    };
    return reasonMap[reason] || reason.toUpperCase();
}

/**
 * Calculating Australia post labels
 * @param shipmentId
 * @param parcels - parcel information for auspost label creation in magento {parcelType, parcelItems}
 * @param createdAt
 * @returns {Function}
 */
export function calculateLabels(shipmentId, parcels, createdAt, rejectedItems = null) {
    return (dispatch, getState) => {
        dispatch(loading(true));

        console.log('Rejected Items in calculateLabels:', rejectedItems);

        const getFinalWeight = (shipmentItems, packagingWeight) => {
            return Number(Number(shipmentItems.reduce((total, item) => {
                return total + item.weight
            }, 0) + packagingWeight).toFixed(3));
        }

        // Transform parcels into package_composition format
        const packageComposition = parcels.map(parcel => {
            const packagingWeight = parcel.parcelType === 9 ? 0.05 : 0.02;
            return {
                shipment_items: parcel.items.map(item => ({
                    shipment_item_id: item.shipmentItemId,
                    weight: Number(Number(item.weight).toFixed(3)),
                })).filter(item => !rejectedItems || !rejectedItems.some(rej => rej?.shipmentItemId === item.shipment_item_id)),
                packaging_weight: packagingWeight,
                final_weight: getFinalWeight(parcel.items, packagingWeight)
            }
        });

        console.log(JSON.stringify(packageComposition));

        // Get shipping address from shipment
        const shipment = getState().shippingState.shipments.find(s => s.shipmentId === shipmentId);
        if (!shipment) {
            dispatch(notification.errorNotification('Shipment not found'));
            dispatch(loading(false));
            return;
        }

        console.log('Shipment:', shipment); // Debug log

        // Safely get shipping address data from customerData
        const shippingAddress = {
            first_name: shipment.customerData?.fName || "",
            last_name: shipment.customerData?.lName || "",
            company: shipment.customerData?.company || "",
            street_one: shipment.customerData?.address || "",
            street_two: shipment.customerData?.address2 || "",
            city: shipment.customerData?.city || "",
            postcode: shipment.customerData?.postcode || "",
            state: shipment.customerData?.state || shipment.customerData?.region || "QLD", // try both state and region
            country: shipment.customerData?.country || "",
            phone_number: shipment.customerData?.phone || ""
        };

        console.log('Shipping Address:', shippingAddress); // Debug log

        const fulfiller = getState().shippingState.fulfiller.name;
        const fulfilledAt = moment().format('YYYY-MM-DD HH:mm:ss');
        // const fulfilledAt = moment.utc().format('YYYY-MM-DD HH:mm:ss');

        dispatch(fetchLabel(shipmentId, packageComposition, shippingAddress, fulfiller, fulfilledAt, rejectedItems))
            .then(response => {
                if (response.error) {
                    dispatch(notification.errorNotification(errorTypes[response.error] ? errorTypes[response.error] : "Error calculating Label! Please contact dev support"));
                    dispatch(loading(false));
                    dispatch(updateShipmentStage('STAGE_TWO', shipmentId));
                } else if (response.code === 200 && response.data?.label_url) {
                    // const labelUrl = response.data.label_url;
                    // console.log('label', labelUrl);
                    // printPreview(labelUrl);

                    dispatch(setLabels(shipmentId, response.data.label_url));
                    dispatch(updateShipmentStage('STAGE_THREE', shipmentId));
                    dispatch(loading(false));
                } else {
                    dispatch(notification.errorNotification('Invalid response format from label service'));
                    dispatch(loading(false));
                    dispatch(updateShipmentStage('STAGE_TWO', shipmentId));
                }
            })
            .catch((e) => {
                console.log(e.message);
                dispatch(notification.errorNotification('Network error! Please try again'));
                dispatch(loading(false));
                dispatch(updateShipmentStage('STAGE_TWO', shipmentId));
            });
    };
}

// Helper function to calculate final weight
function calculateFinalWeight(parcel) {
    const itemsWeight = parcel.items.reduce((sum, item) => sum + (parseFloat(item.weight) || 0.2), 0);
    const packagingWeight = parseFloat(parcel.parcelType.weight) || 0.1;
    return (itemsWeight + packagingWeight).toFixed(1);
}

export function getFulfillerData  (futuraId) {
    return(dispatch,getState) => {
        dispatch(loading(true));
        let storeId = getState().authState.store;

        dispatch(fetchFulfillerData(storeId, futuraId)).then(response => {
            if (!response.status) {
                dispatch(notification.errorNotification(response.error + '! Please try again'));
                dispatch(loading(false));
            } else {
                console.log('fulfiller', response.fulfillerInfo);
                dispatch(updateFulfiller(response.fulfillerInfo));
                dispatch(store.fetchSingleStore(storeId)).then(response => {
                    if (response.pickupInfo) {
                        dispatch(setAuspostInfo(response.pickupInfo));
                        dispatch(loading(false));
                        dispatch(loggedIn(true));
                    }
                }).catch((e) => {
                    checkSession();
                    console.log(e);
                    dispatch(loading(false));
                });
            }
        }).catch((e) => {
            checkSession();
            console.log(e);
            dispatch(loading(false));
        })
    }
}

export function getStorePendingCount(){
    return (dispatch,getState) => {
        let store = getState().authState.store;
        dispatch(fetchPendingDetails(store)).then(response=>{
            //console.log(response);
            dispatch(addPendingOverview(response.data));
        })
    }
}

export function getPickslips(shipmentId) {
    return (dispatch, getState) => {
        dispatch(loading(true));
        let newTab = null;

        try {
            newTab = window.open('', '_blank');
            if (!newTab) {
                dispatch(notification.errorNotification('Pop-up blocked. Please allow pop-ups for this site to view pickslips.'));
                dispatch(loading(false));
                return Promise.resolve();
            }
            // Optionally, provide immediate feedback in the new tab
            newTab.document.write('Loading pickslip, please wait...');
        } catch (e) {
            console.error('Error trying to open new tab:', e);
            dispatch(notification.errorNotification('Could not open new tab. Please check your browser settings.'));
            dispatch(loading(false));
            return Promise.resolve(); // Indicate completion
        }

        const store = getState().authState.store;

        return dispatch(fetchPickslip(shipmentId, store))
            .then(response => {
                if (response.code === 200 && response.data?.pickslip_url) {
                    const randomQuery = Math.random();
                    const pickslipUrl = `${config.s3.PICKSLIPS}${response.data.pickslip_url}?${randomQuery}`;

                    // Navigate the already opened tab to the pickslip URL
                    newTab.location.href = pickslipUrl;
                } else {
                    if (newTab) {
                        // Provide an error message in the new tab if fetching failed
                        newTab.document.body.innerHTML = 'Failed to load pickslip information. You may close this tab.';
                    }
                    dispatch(notification.errorNotification('Failed to load pickslip'));
                }
            })
            .catch(error => {
                console.error('Error loading pickslip:', error);
                if (newTab) {
                    // Provide an error message in the new tab in case of an exception
                    newTab.document.body.innerHTML = 'An error occurred while loading the pickslip. You may close this tab.';
                }
                dispatch(notification.errorNotification('Error loading pickslip'));
            })
            .finally(() => {
                // Ensure loading state is reset regardless of outcome
                dispatch(loading(false));
            });
    };
}

export function getAllPickslips(store, type, web_store){
    if (type !== 'all') {
        return (dispatch,getState) => {
            dispatch(loading(true));

            // Safari only allows window.open synchronously within a user gesture,
            // so the tab is opened before fetching and navigated once the URL is known
            let newTab = null;
            try {
                newTab = window.open('', '_blank');
                if (!newTab) {
                    dispatch(notification.errorNotification('Pop-up blocked. Please allow pop-ups for this site to view pickslips.'));
                    dispatch(loading(false));
                    return Promise.resolve();
                }
                newTab.document.write('Loading pickslips, please wait...');
            } catch (e) {
                console.error('Error trying to open new tab:', e);
                dispatch(notification.errorNotification('Could not open new tab. Please check your browser settings.'));
                dispatch(loading(false));
                return Promise.resolve();
            }

            dispatch(notification.warningNotification('Pickslips will open in a new tab when loaded'));
            let store = parseInt(getState().authState.store);

            return dispatch(fetchAllPickslips(store, type, web_store))
                .then(response => {
                    if (response.data?.pickslip_url) {
                        const randomQuery = Math.random();
                        newTab.location.href = config.s3.PICKSLIPS + response.data.pickslip_url + '?' + randomQuery;
                    } else {
                        newTab.document.body.innerHTML = 'Failed to load pickslip information. You may close this tab.';
                        dispatch(notification.errorNotification('Failed to load pickslips'));
                    }
                })
                .catch(error => {
                    console.error('Error loading pickslips:', error);
                    if (newTab) {
                        newTab.document.body.innerHTML = 'An error occurred while loading the pickslips. You may close this tab.';
                    }
                    dispatch(notification.errorNotification('Error loading pickslips'));
                })
                .finally(() => {
                    dispatch(loading(false));
                });
        }
    } else {
        return (dispatch,getState) => {
            let store = getState().authState.store;
            let randomQuery = Math.random();
            const pickslip_name = `${store.toLowerCase()}_${type.toLowerCase()}_${web_store ? `${web_store.toLowerCase()}_` : ''}}pickslips.pdf?`;
            const theWindow = window.open(config.s3.PICKSLIPS + pickslip_name + randomQuery);
            const theDoc = theWindow.document;
            const theScript = document.createElement('script');
            function injectThis() {
                window.location.reload();
            }
            theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
            theDoc.body.appendChild(theScript);
        }
    }
}

const isToday = (someDate) => {
    return moment.tz("Australia/Brisbane").isSame(someDate, 'day');
};

const printPreview = (data, type = 'application/pdf') => {
    let blob = b64toBlob(data, type);
    const blobURL = URL.createObjectURL(blob);
    return blobURL;
};

const b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
        type: contentType
    }); // statement which creates the blob
    return blob;
};

/**
 * Generating a click and collect label
 * @param shipment - The shipment object containing shipmentId and brand
 * @param parcels - The parcels to include in the label
 * @returns {Function}
 */
export function generateCCLabel(shipment,parcels){
    return (dispatch,getState) => {
        let shipmentId = shipment.shipmentId;
        let store = getState().authState.store;
        let brand = shipment.brand;
        dispatch(loading(true));
        dispatch(updateShipmentStage('STAGE_THREE',shipmentId));
        dispatch(loading(false));

        // Safari only allows window.open synchronously within a user gesture,
        // so the tab is opened before fetching and navigated once the URL is known.
        // 'noopener' must not be passed here — it makes window.open return null,
        // which leaves no handle to navigate the tab with
        let newTab = null;
        try {
            newTab = window.open('', '_blank');
            if (newTab) {
                newTab.document.write('Loading label, please wait...');
            } else {
                dispatch(notification.errorNotification('Pop-up blocked. Please allow pop-ups to view pickslip.'));
            }
        } catch (e) {
            console.error('Error trying to open new tab:', e);
        }

        dispatch(fetchCCLabel(store, shipmentId, brand)).then(response=>{
            if(response.message === 'success' && response.data.pickslip_url){
                const randomQuery = Math.random();
                const pickslipUrl = `${config.s3.PICKSLIPS}${response.data.pickslip_url}?${randomQuery}`;

                if (newTab) {
                    newTab.location.href = pickslipUrl;
                }

                dispatch(setLabels(shipmentId, pickslipUrl));
                dispatch(updateShipmentStage('STAGE_THREE',shipmentId));
                dispatch(loading(false));
            }else {
                if (newTab) {
                    newTab.document.body.innerHTML = 'Failed to load the label. You may close this tab.';
                }
                dispatch(notification.errorNotification('Network error! Please try again or contact dev support'));
                dispatch(loading(false));
                dispatch(updateShipmentStage('STAGE_TWO',shipmentId));
            }
        }).catch((e)=>{
            if (newTab) {
                newTab.document.body.innerHTML = 'An error occurred while loading the label. You may close this tab.';
            }
            dispatch(notification.errorNotification('Error creating label! please contact dev support'));
            dispatch(loading(false));
            dispatch(updateShipmentStage('STAGE_TWO',shipmentId));
            console.log(e);
        })
    }
}

function checkSession(){
    return (dispatch) => {
        cogLib.checkActiveSession().then(response => {
            dispatch(notification.errorNotification('please refresh the page'));
        });
    }
}

/**
 * When an item has a manufacturing fault this function creates a pdf for the store to stick to the item.
 * this pdf contains Date,Ibt,staff till number, sku,
 * @param data
 * @return {string}
 */
function createFaultyItemPdf(data) {
    let {ibt, fulfiller, skus, qty} = data
    let doc = new jsPDF();
    let ibt_number = ibt ? ibt : "not assigned"
    let staff_number = fulfiller ? fulfiller : "unknown"
    let r_codes = skus ? skus.join() : "unknown"
    doc.setFontSize(26);
    doc.text("Date: " + new Date().toLocaleDateString(), 15, 25);
    doc.text("IBT NUMBER: " + ibt_number, 15, 45);
    doc.text("R_CODES: " + r_codes, 15, 65);
    doc.text("Total Units: " + qty, 15, 85);
    doc.text("STAFF NUMBER: " + staff_number, 15, 110);
    let dataURL = doc.output();
    return btoa(dataURL);
}

/**
 * Takes in any number of shipments and returns true if at least one shipment is a high priority shipment
 * (Same Day or CC that is not 'fulfilled')
 *
 * @param shipments
 * @returns {boolean}
 */
function isPriorityShipment(...shipments) {
    for (let shipment of shipments) {
        if (shipment.method === METHOD.SAME_DAY) {return true;}
        if (shipment.method === METHOD.CLICKCOLLECT && shipment.status !== STATUS.FULFILLED) {return true;}
    }
    return false;
}

/**
 * Compares two shipments where at least one is a high priority shipment.
 * If both shipments are high priority sort by createdAt date otherwise sort based on the shipment with higher
 * priority.
 *
 * @param shipmentA
 * @param shipmentB
 * @returns {number|number}
 */
function comparePriorityShipment(shipmentA, shipmentB) {

    //Both Shipments are High Priority determine order based on createdAt
    if ((shipmentA.method === METHOD.SAME_DAY || shipmentA.method === METHOD.CLICKCOLLECT) &&
        (shipmentB.method === METHOD.SAME_DAY || shipmentB.method === METHOD.CLICKCOLLECT)) {
        return new Date(shipmentA.createdAt) - new Date(shipmentB.createdAt);
    }

    //At least one of the shipments is high priority. Therefore if shipmentA doesn't contain a high priority method
    //shipmentB is the higher priority shipment.
    return (shipmentA.method !== METHOD.SAME_DAY && shipmentA.method !== METHOD.CLICKCOLLECT) ? 1 : -1;
}

/**
 * Compare two shipments where both shipments are NOT high priority. If shipping methods are the same sort based on
 * createdAt date. Otherwise sort by Express -> Standard -> CC (pending pickup)
 *
 * @param shipmentA
 * @param shipmentB
 * @returns {number}
 */
function compareShipment(shipmentA, shipmentB) {
    //Shipments with Labels printed but incomplete should be up the top
    if (shipmentA.labelsPrinted || shipmentB.labelsPrinted) {
        return (shipmentA.labelsPrinted) ? -1 : 1;
    }

    //Both Shipments have the same method sort by createdAt
    if (shipmentA.method === shipmentB.method) {
        return new Date(shipmentA.createdAt) - new Date(shipmentB.createdAt);
    }

    //Express takes priority over standard
    if (shipmentA.method === METHOD.EXPRESS && shipmentB.method === METHOD.STANDARD) {
        return -1;
    }

    if (shipmentA.method === METHOD.STANDARD && shipmentB.method === METHOD.EXPRESS) {
        return 1;
    }

    //Only Options left are CC (fulfilled) and Standard/Express. fulfilled shipments are the lowest priority
    return (shipmentA.status === STATUS.FULFILLED) ? 1 : -1;
}

/**
 * Collects a shipment using the shipment ID
 * @param {string} shipmentId - ID of the shipment to collect
 * @returns {Function} - Redux thunk function
 */
export function collectShipment(barcodes, collectionCode, storeId) {
    return (dispatch) => {
        console.log('Attempting to collect shipment with:', barcodes, collectionCode, storeId);
        return lambda.collectShipment(barcodes, collectionCode, storeId)
            .then(response => {
                console.log('Collect shipment response:', response);
                return response;
            })
            .catch(error => {
                console.error('Error in collectShipment:', error);
                throw error;
            });
    };
}

export function getRecentFulfilledShipments() {
    return (dispatch, getState) => {
        dispatch(loadingFulfilled(true));
        const store = getState().authState.store;

        return lambda.getRecentFulfilledShipments(store).then(response => {
            console.log('Recent fulfilled shipments response:', response);
            if(response && response.data && response.data.shipments) {
                // Map shipments to internal format
                const mappedShipments = response.data.shipments.map(shipment => {
                    // Extract items from packages if shipment_items is empty
                    let items = [];
                    if (shipment.shipment_items && shipment.shipment_items.length > 0) {
                        items = shipment.shipment_items.map(item => ({
                            shipmentItemId: item.shipment_item_id,
                            name: item.name,
                            size: item.size,
                            sku: item.sku,
                            imageUrl: item.image_url,
                            localId: item.sku,
                            availability: true,
                            reason: null
                        }));
                    } else if (shipment.packages && shipment.packages.length > 0) {
                        items = shipment.packages.flatMap(pkg =>
                            pkg.items ? pkg.items.map(item => ({
                                shipmentItemId: item.shipment_item_id,
                                name: item.name,
                                size: item.size,
                                sku: item.sku,
                                imageUrl: item.image_url,
                                localId: item.sku,
                                availability: true,
                                reason: null
                            })) : []
                        );
                    }

                    return {
                        shipmentId: shipment.shipment_id,
                        incrementId: shipment.increment_id,
                        orderDate: shipment.created_at,
                        status: shipment.status,
                        stage: shipment.stage,
                        method: shipment.shipping_method,
                        carrier: shipment.carrier,
                        brand: shipment.brand,
                        customerName: shipment.customer_name,
                        customerAddress: shipment.customer_address,
                        customerPhone: shipment.customer_phone,
                        labelsPrinted: shipment.labels_printed || false,
                        fulfilledAt: shipment.fulfilled_at,
                        localLabelUrl: shipment.local_label_url,
                        pickslipUrl: shipment.pickslip_url,
                        items: items,
                        isSearched: true
                    };
                });

                dispatch(addFulfilledShipments(mappedShipments));
                dispatch(loadingFulfilled(false));
                return mappedShipments;
            } else {
                dispatch(addFulfilledShipments([]));
                dispatch(loadingFulfilled(false));
                return [];
            }
        }).catch(error => {
            console.error('Error loading recent fulfilled shipments:', error);
            dispatch(addFulfilledShipments([]));
            dispatch(loadingFulfilled(false));
            throw error;
        });
    };
}